import { backendApi } from "@/services/backend/api";
import {
  BranchesResponse,
  CompanyReference,
  CreatedResponse,
  CreateRequest,
  DeleteRequest,
  EmptyResponse,
  GetRequest,
  ListRequest,
  ListResponse,
  UpdateRequest,
} from "@/services/backend/qpm/company-references/types/company-reference";

const qpmCompanyReferenceApi = backendApi
  .enhanceEndpoints({ addTagTypes: ["QpmCompanyReference"] })
  .injectEndpoints({
    endpoints: (build) => ({
      qpmCompanyReferenceCreate: build.mutation<CreatedResponse, CreateRequest>(
        {
          query: (request) => ({
            url: `/qpm/companyreferences`,
            method: "POST",
            body: request,
          }),
          invalidatesTags: [{ type: "QpmCompanyReference", id: "LIST" }],
        },
      ),

      qpmCompanyReferenceGet: build.query<CompanyReference, GetRequest>({
        query: (request) => ({
          url: `/qpm/companyreferences/get`,
          method: "GET",
          params: request,
        }),
        providesTags: (result) =>
          result
            ? [{ type: "QpmCompanyReference", id: result.id }]
            : [{ type: "QpmCompanyReference", id: "LIST" }],
      }),

      qpmCompanyReferenceList: build.query<ListResponse, ListRequest>({
        query: (request) => ({
          url: `/qpm/companyreferences/list`,
          method: "GET",
          params: request,
        }),
        providesTags: (result) =>
          result
            ? [
                { type: "QpmCompanyReference", id: "LIST" },
                ...result.items.map((it) => ({
                  type: "QpmCompanyReference" as const,
                  id: it.id,
                })),
              ]
            : [{ type: "QpmCompanyReference", id: "LIST" }],
      }),

      qpmCompanyReferenceBranches: build.query<BranchesResponse, void>({
        query: () => ({
          url: `/qpm/companyreferences/branches`,
          method: "GET",
        }),
        providesTags: [{ type: "QpmCompanyReference", id: "BRANCHES" }],
      }),

      qpmCompanyReferenceUpdate: build.mutation<EmptyResponse, UpdateRequest>({
        query: (request) => ({
          url: `/qpm/companyreferences`,
          method: "PUT",
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: "QpmCompanyReference", id: "LIST" },
          { type: "QpmCompanyReference", id: arg.id },
          { type: "QpmCompanyReference", id: "BRANCHES" },
        ],
      }),

      qpmCompanyReferenceDelete: build.mutation<EmptyResponse, DeleteRequest>({
        query: (request) => ({
          url: `/qpm/companyreferences`,
          method: "DELETE",
          body: request,
        }),
        invalidatesTags: (result, error, arg) => [
          { type: "QpmCompanyReference", id: "LIST" },
          { type: "QpmCompanyReference", id: arg.id },
          { type: "QpmCompanyReference", id: "BRANCHES" },
        ],
      }),
    }),
  });

export const {
  useQpmCompanyReferenceCreateMutation,
  useQpmCompanyReferenceGetQuery,
  useQpmCompanyReferenceListQuery,
  useQpmCompanyReferenceBranchesQuery,
  useQpmCompanyReferenceUpdateMutation,
  useQpmCompanyReferenceDeleteMutation,
} = qpmCompanyReferenceApi;
